module.exports = __webpack_public_path__ + "static/josh7-fcc14702420fe6d1e1ca1b197f811ce0.jpg";